import React from 'react'

export const useBackground = () => {
  React.useEffect(() => {
    document.body.classList.add("imagen3");
  }, []);
}
